const BASE_URL = process.env.REACT_APP_API_URL || 'https://gh.api.jaf.com.pt/api';

export default BASE_URL;
